enum PaymentType{
  PaymentTypePending = 1,
  PaymentTypeFinal = 2,
}
export default PaymentType;
